import React from 'react';

const AppContext = React.createContext({});
export const useFeatureFlags = () => React.useContext(AppContext);
export default AppContext;
